import { useTranslations } from '@vocab/react';
import { Drawer } from 'braid-design-system';
import type { FC, ReactNode } from 'react';

import type { FilterFns } from 'src/components/app/FilterSideBar/useFilters';

import { FilterClearButton } from '../FilterClearButton/FilterClearButton';

import translations from './.vocab';

interface FilterDrawerTablet {
  isOpen: boolean;
  close: () => void;
  content: ReactNode;
  shouldShowClearFilterButton: boolean;
  resetFilters: FilterFns['resetFilters'];
}

export const FilterDrawerTablet: FC<FilterDrawerTablet> = ({
  isOpen,
  close,
  content,
  shouldShowClearFilterButton,
  resetFilters,
}) => {
  const { t } = useTranslations(translations);

  return (
    <Drawer
      id="filter-drawer-tablet"
      width="small"
      title={t('Filters')}
      open={isOpen}
      onClose={() => close()}
    >
      {content}
      {shouldShowClearFilterButton ? (
        <FilterClearButton bleed={false} showIcon resetFilters={resetFilters} />
      ) : null}
    </Drawer>
  );
};
